import { useIntl } from 'react-intl';
import { IconCustomAurora } from '@rossum/ui/icons/tabler';
import {
  alpha,
  Box,
  Skeleton,
  Stack,
  SvgIcon,
  Typography,
  useTheme,
} from '@rossum/ui/material';
import { borderRadius } from '@rossum/ui/theme';
import { button } from '../../../../lib/formaterValues';
import { Summary } from './Summary';

type SummaryBoxProps =
  | {
      variant: 'emptyFormula' | 'emptyRule';
      callback: () => void;
      value?: undefined;
      onClick?: undefined;
      disabled?: boolean;
    }
  | {
      variant: 'editingCode';
      value?: undefined;
      onClick?: undefined;
      callback: () => void;
      disabled?: boolean;
    }
  | {
      variant: 'missingInfoFormula' | 'missingInfoRule' | 'suggestingSummary';
      value?: undefined;
      onClick?: undefined;
      callback?: undefined;
      disabled?: boolean;
    }
  | {
      value: string;
      onClick?: () => void;
      variant?: undefined;
      callback?: undefined;
      disabled?: boolean;
    };

export const SummaryBox = ({
  value,
  variant,
  callback,
  onClick,
  disabled,
}: SummaryBoxProps) => {
  const theme = useTheme();
  const intl = useIntl();
  return (
    <Stack
      width="100%"
      alignItems="center"
      onClick={onClick}
      sx={{ cursor: onClick ? 'pointer' : undefined }}
    >
      <Box
        py={1}
        px={2}
        sx={{
          width: '100%',
          border: disabled
            ? `1px solid ${theme.palette.action.disabled}`
            : `1px solid ${value ? theme.palette.aurora.light : theme.palette.action.active}`,
          borderRadius: borderRadius('s'),
          backgroundColor: disabled
            ? alpha(theme.palette.action.disabledBackground, 0.1)
            : alpha(
                value ? theme.palette.aurora.main : theme.palette.action.active,
                0.1
              ),
        }}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <Stack width="100%" textAlign={value ? 'left' : 'center'} p={2}>
            {value !== undefined ? (
              <Stack direction="row" alignItems="start" spacing={1}>
                <SvgIcon
                  fontSize="medium"
                  sx={{ color: t => t.palette.aurora.light }}
                >
                  <IconCustomAurora />
                </SvgIcon>
                <Summary content={value} />
              </Stack>
            ) : (
              <Stack sx={{ opacity: 0.7 }}>
                {variant === 'suggestingSummary' ? (
                  <>
                    <Skeleton />
                    <Skeleton />
                  </>
                ) : (
                  <>
                    <Typography variant="h6">
                      {intl.formatMessage({
                        id: `features.formulas.summaryBox.${variant}.title`,
                      })}
                    </Typography>
                    <Typography variant="body2">
                      {intl.formatMessage(
                        {
                          id: `features.formulas.summaryBox.${variant}.description`,
                        },

                        {
                          button: callback ? button(callback) : undefined,
                        }
                      )}
                    </Typography>
                  </>
                )}
              </Stack>
            )}
          </Stack>
        </Stack>
      </Box>
    </Stack>
  );
};
